// External libraries
// @ts-expect-error TODO: Type or global ignore react-components
import { isString } from '@checkout/react-components';

// Internal modules
import { useOnMount } from './useOnMount';
import { logger } from '../logger';

const COMPONENT_NAME_REGEX = /([a-z])([A-Z])/g;

const mapNameToSnakeCase = (name: string): string => {
  return isString(name)
    ? name.replace(COMPONENT_NAME_REGEX, '$1_$2').toLowerCase()
    : '';
};

const useMountLogging = (componentName: string): void => {
  const component = mapNameToSnakeCase(componentName);

  useOnMount(() => {
    logger.info(`weasley_${component}_component_mounted`);
    return () => {
      logger.info(`weasley_${component}_component_unmounted`);
    };
  });
};

export { useMountLogging };
